import * as THREE from 'three';
import { resolveConnectorEndpoint, } from './entityAnchorResolution.js';
function toVector3(tuple) {
    return new THREE.Vector3(tuple[0], tuple[1], tuple[2]);
}
/** Converts a world-space anchor into an offset in the item's local label space. */
export function resolveAnchorPlacedLabelOffset(args) {
    const { anchorRef, localOffset, context, itemWorldPosition, labelFrameRotation } = args;
    const resolvedAnchor = resolveConnectorEndpoint({ endpoint: anchorRef, context });
    if (!resolvedAnchor)
        return null;
    const offset = toVector3(resolvedAnchor.position).sub(toVector3(itemWorldPosition));
    offset.applyQuaternion((labelFrameRotation ?? new THREE.Quaternion()).clone().invert());
    offset.add(toVector3(localOffset));
    return [offset.x, offset.y, offset.z];
}
